import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [email, setEmail] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  useState(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    
    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append('email', email);
      
      await fetch('https://readdy.ai/api/form/d4t67s6u005hmhpl84n0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString()
      });
      
      setEmail('');
      alert('ご登録ありがとうございます');
    } catch (error) {
      alert('エラーが発生しました');
    }
  };

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');
    
    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });
      
      await fetch('https://readdy.ai/api/form/d4t67mmu005hmhpl84mg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString()
      });
      
      setSubmitStatus('success');
      setFormData({ name: '', company: '', email: '', phone: '', message: '' });
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const propertyImages = [
    'https://static.readdy.ai/image/b1826dfd28f8ae8dc417d16e3d601b0d/bde1c4a2eb8f431750d9cc6fb9199666.jpeg',
    'https://static.readdy.ai/image/b1826dfd28f8ae8dc417d16e3d601b0d/c88e3fbdca915cdfe7f30a7530d70a12.jpeg',
    'https://static.readdy.ai/image/b1826dfd28f8ae8dc417d16e3d601b0d/0126f53b1eed750adccc80ca6691ed47.jpeg',
    'https://static.readdy.ai/image/b1826dfd28f8ae8dc417d16e3d601b0d/cadd6cc84e7baf114b01c78d15368e56.jpeg'
  ];

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img src="https://public.readdy.ai/ai/img_res/08ecdc57-e470-42d2-b678-95c295b172d1.png" alt="Logo" className="h-10 w-auto" />
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#property" className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}>物件詳細</a>
            <a href="#location" className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}>アクセス</a>
            <a href="#contact" className="bg-[#1e3a5f] text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-[#2d4a6f] transition-colors cursor-pointer whitespace-nowrap">内見予約</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center pb-32 md:pb-0" style={{ fontFamily: "'Noto Serif JP', serif" }}>
        <div className="absolute inset-0 w-full h-full">
          <img 
            src="https://static.readdy.ai/image/b1826dfd28f8ae8dc417d16e3d601b0d/63b2a51e44e3b8162d6710831d3b626a.jpeg" 
            alt="Hero Background" 
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
          <div className="max-w-2xl">
            <div className="flex flex-wrap gap-3 mb-6">
              <div className="inline-block bg-[#84cc16] text-white px-4 py-2 rounded-full text-sm font-bold">
                2026年5月以降入居可
              </div>
              <div className="inline-block bg-[#f59e0b] text-white px-4 py-2 rounded-full text-sm font-bold">
                🌿 テラス付き
              </div>
            </div>
            <h1 className="text-4xl md:text-7xl font-bold text-white mb-6 leading-tight">
              銀座駅徒歩5分<br />テラス付き<br />プレミアムオフィス
            </h1>
            <p className="text-lg md:text-xl text-white/90 mb-4 font-light">
              52.26坪 / 専用テラス24.17坪
            </p>
            <p className="text-3xl md:text-4xl font-bold text-white mb-10">
              賃料 要相談
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="#property" className="bg-[#1e3a5f] text-white px-8 py-4 rounded-lg text-base font-medium hover:bg-[#2d4a6f] transition-colors cursor-pointer whitespace-nowrap">詳細を見る</a>
              <a href="#contact" className="bg-white text-[#1e3a5f] px-8 py-4 rounded-lg text-base font-medium hover:bg-gray-50 transition-colors border-2 border-white cursor-pointer whitespace-nowrap">内見予約</a>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="absolute bottom-0 left-0 right-0 z-10">
          <div className="max-w-7xl mx-auto px-6 pb-6 md:pb-12">
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
                <div className="text-center">
                  <div className="text-2xl md:text-4xl font-bold text-[#1e3a5f] mb-1 md:mb-2">52.26坪</div>
                  <div className="text-xs md:text-sm text-gray-600">広々とした空間</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-4xl font-bold text-[#1e3a5f] mb-1 md:mb-2">徒歩5分</div>
                  <div className="text-xs md:text-sm text-gray-600">銀座駅から</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-4xl font-bold text-[#f59e0b] mb-1 md:mb-2">🌿 24.17坪</div>
                  <div className="text-xs md:text-sm text-gray-600">専用テラス</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-4xl font-bold text-[#1e3a5f] mb-1 md:mb-2">2026年5月</div>
                  <div className="text-xs md:text-sm text-gray-600">入居可能時期</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-24 bg-[#faf9f7]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f] mb-4">
              🏢 この物件の<br />3つの魅力
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="group relative overflow-hidden rounded-2xl aspect-[3/4] cursor-pointer">
              <img 
                src="https://public.readdy.ai/ai/img_res/72bc2ab63c1a1ecac7fdf61af80b7ea4.jpg" 
                alt="テラス付き" 
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <div className="inline-block bg-[#f59e0b] px-3 py-1 rounded-full text-xs font-bold mb-3">
                  🌿 特別な空間
                </div>
                <h3 className="text-2xl font-bold mb-3">専用テラス完備</h3>
                <p className="text-sm leading-relaxed opacity-90">開放的な屋外スペースで、リフレッシュやミーティングに最適。都心で自然を感じられる贅沢な環境です。</p>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl aspect-[3/4] cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=Ginza%20Tokyo%20cityscape%20with%20luxury%20buildings%20elegant%20streets%20sophisticated%20urban%20landscape%20daytime%20view%20prestigious%20location%20convenient%20transportation%20hub%20vibrant%20upscale%20business%20district&width=600&height=800&seq=ginzafeature3&orientation=portrait" 
                alt="抜群の立地" 
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <h3 className="text-2xl font-bold mb-3">銀座駅徒歩5分</h3>
                <p className="text-sm leading-relaxed opacity-90">都心の一等地、銀座駅から徒歩わずか5分。アクセス抜群で通勤も便利です。</p>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl aspect-[3/4] cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=Business%20team%20planning%20office%20move%20with%20documents%20and%20furniture%20consultation%20efficient%20relocation%20professional%20workspace%20bright%20modern%20interior%20ready%20for%20business%20premium%20Ginza%20office&width=600&height=800&seq=ginzafeature4&orientation=portrait" 
                alt="即入居可能" 
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <h3 className="text-2xl font-bold mb-3">2026年5月以降入居可</h3>
                <p className="text-sm leading-relaxed opacity-90">入居時期についてはご相談に応じます。お気軽にお問い合わせください。</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Terrace Highlight Section */}
      <section className="py-24 bg-gradient-to-br from-[#f0fdf4] to-[#fef3c7]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="relative overflow-hidden rounded-3xl shadow-2xl aspect-[4/3] w-full h-96">
                <img 
                  src="https://static.readdy.ai/image/b1826dfd28f8ae8dc417d16e3d601b0d/c88e3fbdca915cdfe7f30a7530d70a12.jpeg" 
                  alt="テラス詳細" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#f59e0b] text-white rounded-full text-2xl">
                    🌿
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-[#1e3a5f]">24.17坪</div>
                    <div className="text-sm text-gray-600">専用テラス</div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="inline-block bg-[#f59e0b] text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                🌿 TERRACE SPACE
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f] mb-6 leading-tight">
                都心で自然を感じる<br />プライベートテラス
              </h2>
              <p className="text-gray-700 text-lg mb-8 leading-relaxed">
                約24.17坪の広々とした専用テラスは、リフレッシュやカジュアルなミーティングに最適。緑に囲まれた開放的な空間で、創造性を高め、チームの絆を深めることができます。
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#84cc16]/10 text-[#84cc16] rounded-full flex-shrink-0">
                    <i className="ri-plant-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-[#1e3a5f] mb-1">緑豊かな環境</h4>
                    <p className="text-gray-600 text-sm">植栽やプランターで自然を感じられる癒しの空間</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#84cc16]/10 text-[#84cc16] rounded-full flex-shrink-0">
                    <i className="ri-team-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-[#1e3a5f] mb-1">多目的利用</h4>
                    <p className="text-gray-600 text-sm">ランチ、休憩、ミーティング、イベントなど自由に活用</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#84cc16]/10 text-[#84cc16] rounded-full flex-shrink-0">
                    <i className="ri-sun-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-[#1e3a5f] mb-1">開放的な眺望</h4>
                    <p className="text-gray-600 text-sm">都心の景色を一望できる贅沢なロケーション</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Property Details Section */}
      <section id="property" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-16">
            <div className="text-sm font-bold text-gray-400 mb-2 tracking-wider">PROPERTY DETAILS</div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f]" style={{ fontFamily: "'Noto Serif JP', serif" }}>物件詳細</h2>
          </div>

          {/* Image Gallery */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-16">
            <div className="relative overflow-hidden rounded-3xl aspect-[4/3] w-full h-96">
              <img 
                src={propertyImages[0]} 
                alt="オフィス内観1" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              {propertyImages.slice(1).map((img, index) => (
                <div key={index} className="relative overflow-hidden rounded-3xl aspect-square w-full h-full">
                  <img 
                    src={img} 
                    alt={`オフィス内観${index + 2}`} 
                    className="w-full h-full object-cover object-top"
                  />
                  {index === 0 && (
                    <div className="absolute top-3 left-3 bg-[#f59e0b] text-white px-3 py-1 rounded-full text-xs font-bold">
                      🌿 テラス
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Property Info */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-bold text-[#1e3a5f] mb-6">物件概要</h3>
              <div className="space-y-4">
                <div className="flex border-b border-gray-200 pb-4">
                  <div className="w-32 text-gray-600 font-medium">所在地</div>
                  <div className="flex-1 text-gray-900">東京都中央区銀座2丁目</div>
                </div>
                <div className="flex border-b border-gray-200 pb-4">
                  <div className="w-32 text-gray-600 font-medium">アクセス</div>
                  <div className="flex-1 text-gray-900">銀座駅 徒歩5分</div>
                </div>
                <div className="flex border-b border-gray-200 pb-4">
                  <div className="w-32 text-gray-600 font-medium">面積</div>
                  <div className="flex-1 text-gray-900">52.26坪（約173㎡）+ テラス24.17坪（約80㎡）</div>
                </div>
                <div className="flex border-b border-gray-200 pb-4">
                  <div className="w-32 text-gray-600 font-medium">賃料</div>
                  <div className="flex-1 text-gray-900 font-bold text-xl">要相談</div>
                </div>
                <div className="flex border-b border-gray-200 pb-4">
                  <div className="w-32 text-gray-600 font-medium">造作譲渡代</div>
                  <div className="flex-1 text-gray-900 font-bold text-xl">500万円</div>
                </div>
                <div className="flex border-b border-gray-200 pb-4">
                  <div className="w-32 text-gray-600 font-medium">敷金・礼金</div>
                  <div className="flex-1 text-gray-900">要相談</div>
                </div>
                <div className="flex border-b border-gray-200 pb-4">
                  <div className="w-32 text-gray-600 font-medium">入居可能日</div>
                  <div className="flex-1 text-gray-900">2026年5月以降（要相談）</div>
                </div>
                <div className="flex border-b border-gray-200 pb-4">
                  <div className="w-32 text-gray-600 font-medium">引渡状態</div>
                  <div className="flex-1 text-gray-900">要相談</div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#1e3a5f] mb-6">設備・仕様</h3>
              <div className="bg-gradient-to-br from-[#f0fdf4] to-[#fef3c7] rounded-2xl border-2 border-[#f59e0b]/20 p-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#f59e0b] text-white rounded-full text-2xl">
                    🌿
                  </div>
                  <div>
                    <h4 className="font-bold text-[#1e3a5f] text-xl">テラス付き居抜きオフィス</h4>
                  </div>
                </div>
                <p className="text-gray-700 text-base leading-relaxed mb-6">
                  銀座2丁目、銀座駅から徒歩5分という抜群の立地に加え、都心では希少な24.17坪の広々とした専用テラス付き。家具・什器の状態については要相談となります。
                </p>
                <div className="bg-white/80 rounded-xl p-6">
                  <p className="text-gray-700 text-sm leading-relaxed">
                    <strong className="text-[#1e3a5f]">設備・仕様の詳細につきましては、お気軽にお問い合わせください。</strong><br />
                    物件の状態や設備内容について、詳しくご説明いたします。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Location Section */}
      <section id="location" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f] mb-6 leading-tight">
                銀座駅徒歩5分<br />抜群のアクセス
              </h2>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                東京メトロ銀座線・丸ノ内線・日比谷線が利用可能。都内各所へのアクセスが抜群です。
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#1e3a5f] text-white rounded-full font-bold">
                    5分
                  </div>
                  <div>
                    <div className="font-bold text-[#1e3a5f]">銀座駅</div>
                    <div className="text-sm text-gray-600">東京メトロ銀座線・丸ノ内線・日比谷線</div>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#1e3a5f] text-white rounded-full font-bold">
                    7分
                  </div>
                  <div>
                    <div className="font-bold text-[#1e3a5f]">有楽町駅</div>
                    <div className="text-sm text-gray-600">JR山手線・東京メトロ有楽町線</div>
                  </div>
                </div>
              </div>

              <a href="#contact" className="inline-block bg-[#84cc16] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#73b012] transition-colors cursor-pointer whitespace-nowrap">
                内見予約はこちら <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>

            <div className="relative">
              <div className="bg-white rounded-3xl shadow-2xl overflow-hidden aspect-[4/3] w-full h-96">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.2479!2d139.7638!3d35.6717!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188be701836fbb%3A0x604685b30ba99851!2z6YqA5bqn6aeF!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="銀座駅周辺マップ"
                  className="w-full h-full"
                ></iframe>
                <div className="absolute top-6 left-6 bg-white px-4 py-2 rounded-full text-sm font-medium text-[#1e3a5f] shadow-lg">
                  銀座駅周辺
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-12 text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f] mb-4">お問い合わせ</h2>
            <p className="text-lg text-gray-600">物件に関するご質問やご相談はお気軽にお問い合わせください</p>
          </div>

          <div className="max-w-3xl mx-auto bg-gradient-to-br from-gray-50 to-white rounded-3xl shadow-xl p-8 md:p-12 border border-gray-100">
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h3 className="text-2xl font-bold text-[#1e3a5f] mb-4">株式会社インペリアルガーデン</h3>
              <div className="space-y-3 text-gray-700">
                <p className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-[#1e3a5f] mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span>〒160-0022 東京都新宿区新宿1-23-16 関口ビル3階</span>
                </p>
                <p className="flex items-center gap-3">
                  <i className="ri-phone-line text-[#1e3a5f] w-5 h-5 flex items-center justify-center"></i>
                  <a href="tel:03-3355-8890" className="hover:text-[#1e3a5f] transition-colors cursor-pointer font-medium">03-3355-8890</a>
                </p>
                <p className="flex items-center gap-3">
                  <i className="ri-time-line text-[#1e3a5f] w-5 h-5 flex items-center justify-center"></i>
                  <span>営業時間：平日 9:00-18:00</span>
                </p>
                <p className="text-sm text-gray-600">宅建業：東京都知事登録（3）91361号</p>
              </div>
            </div>

            <form id="contact-form" data-readdy-form onSubmit={handleContactSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2 text-left">お名前 *</label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1e3a5f] focus:border-transparent text-sm"
                    placeholder="山田太郎"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2 text-left">会社名</label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={(e) => setFormData({...formData, company: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1e3a5f] focus:border-transparent text-sm"
                    placeholder="株式会社〇〇"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2 text-left">メールアドレス *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1e3a5f] focus:border-transparent text-sm"
                    placeholder="example@email.com"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2 text-left">電話番号</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1e3a5f] focus:border-transparent text-sm"
                    placeholder="03-1234-5678"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2 text-left">お問い合わせ内容 *</label>
                <textarea
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1e3a5f] focus:border-transparent text-sm resize-none"
                  placeholder="お問い合わせ内容をご記入ください（500文字以内）"
                ></textarea>
                <div className="text-right text-xs text-gray-500 mt-1">{formData.message.length}/500</div>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#1e3a5f] text-white py-4 rounded-lg font-medium hover:bg-[#2d4a6f] transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmitting ? '送信中...' : '送信する'}
              </button>

              {submitStatus === 'success' && (
                <div className="mt-4 p-4 bg-green-50 text-green-700 rounded-lg text-sm">
                  お問い合わせありがとうございます。担当者より折り返しご連絡いたします。
                </div>
              )}
              {submitStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-50 text-red-700 rounded-lg text-sm">
                  送信に失敗しました。もう一度お試しください。
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1e3a5f] text-white py-16 mx-6 mb-6 rounded-3xl relative overflow-hidden">
        <div className="absolute bottom-0 left-0 right-0 text-[#2d4a6f] text-[120px] md:text-[180px] font-bold opacity-20 text-center leading-none pb-4">
          OFFICE
        </div>
        
        <div className="max-w-7xl mx-auto px-8 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            <div>
              <h3 className="text-2xl font-bold mb-6 leading-tight">今すぐ<br />内見予約</h3>
            </div>

            <div>
              <h4 className="font-bold mb-4">メニュー</h4>
              <ul className="space-y-3 text-sm text-white/80">
                <li><a href="#property" className="hover:text-white transition-colors cursor-pointer">物件詳細</a></li>
                <li><a href="#location" className="hover:text-white transition-colors cursor-pointer">アクセス</a></li>
                <li><a href="#contact" className="hover:text-white transition-colors cursor-pointer">お問い合わせ</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-4">会社情報</h4>
              <ul className="space-y-3 text-sm text-white/80">
                <li>
                  <div className="font-medium text-white mb-1">株式会社インペリアルガーデン</div>
                  <div className="text-xs leading-relaxed">〒160-0022<br />東京都新宿区新宿1-23-16<br />関口ビル3階</div>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
                  <a href="tel:03-3355-8890" className="hover:text-white transition-colors cursor-pointer">03-3355-8890</a>
                </li>
                <li className="text-xs">営業時間：平日 9:00-18:00</li>
                <li className="text-xs">宅建業：東京都知事登録（3）91361号</li>
              </ul>
            </div>

            <div>
              <p className="text-sm mb-4 leading-relaxed">新着情報を<br />メールで受け取る</p>
              <form id="newsletter-form" data-readdy-form onSubmit={handleNewsletterSubmit} className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="メールアドレス"
                  className="flex-1 px-4 py-2.5 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-white/30 text-sm"
                />
                <button type="submit" className="w-10 h-10 flex items-center justify-center bg-white text-[#1e3a5f] rounded-full hover:bg-gray-100 transition-colors flex-shrink-0 cursor-pointer">
                  <i className="ri-arrow-right-line"></i>
                </button>
              </form>
            </div>
          </div>

          <div className="mt-16 pt-8 border-t border-white/20 text-center text-sm text-white/60">
            <p>&copy; 2025 株式会社インペリアルガーデン. All rights reserved. | <a href="https://www.salon-produce.com/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">公式サイト</a> | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
